export const SENTRY_RELEASE: string | undefined = '9b2420150ff39b3075daae993ba5977a43a6d7e0';
